/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ErrorData } from './ErrorData';
export type ErrorInfo = {
    /**
     * バリデーションエラーの場合はrecordIndexと以下のerrorTypeを返却する。
     * - UNDER_LOWER_LIMIT：下限値を下回っています。
     * - PROHIBITED_ITEM：禁止商品があります。
     * - PBLE_ITEM：PB・留型商品は登録できません。
     * - FIFTY_DISCOUNT：50％以上乖離があるため登録不可
     * - DUPLICATE：すでに同じ内容が登録されています。
     * その他のエラーの場合はrecordIndex=0,errorType=OTHERとしてエラーメッセージを返却する。
     * - OTHER：バリデーション以外のエラー
     *
     */
    errorType?: ErrorInfo.errorType;
    /**
     * エラーメッセージ
     */
    message?: string;
    data?: Array<ErrorData>;
};
export namespace ErrorInfo {
    /**
     * バリデーションエラーの場合はrecordIndexと以下のerrorTypeを返却する。
     * - UNDER_LOWER_LIMIT：下限値を下回っています。
     * - PROHIBITED_ITEM：禁止商品があります。
     * - PBLE_ITEM：PB・留型商品は登録できません。
     * - FIFTY_DISCOUNT：50％以上乖離があるため登録不可
     * - DUPLICATE：すでに同じ内容が登録されています。
     * その他のエラーの場合はrecordIndex=0,errorType=OTHERとしてエラーメッセージを返却する。
     * - OTHER：バリデーション以外のエラー
     *
     */
    export enum errorType {
        UNDER_LOWER_LIMIT = 'UNDER_LOWER_LIMIT',
        PROHIBITED_ITEM = 'PROHIBITED_ITEM',
        PBLE_ITEM = 'PBLE_ITEM',
        FIFTY_DISCOUNT = 'FIFTY_DISCOUNT',
        DUPLICATE = 'DUPLICATE',
        OTHER = 'OTHER',
    }
}

